import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService extends BaseProvider {

  shoppingCartList: any[];
  qtyProducts: number;
  paidList: any;
  listMarkedForPay: any;
  paymentCompleted: boolean = false;
  paymentMethod: number;

  constructor(
    private globals: GlobalsService,
    private http: HttpClient
  ) { 
    super();

    this.baseUrl = "shoppingCart";
  }

  getList(){
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/list`;

      this.http.get(url)
      .subscribe(
        (data: any ) => { 
          resolve(data);
          this.shoppingCartList = data.Data;
          this.qtyProducts = this.shoppingCartList.length;
        },
        (err: any) => { reject(err) }
      );
    });
  }

  addToCart(userProcessId){
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/${userProcessId}`;

      this.http.post(url, {})
      .subscribe(
        (data: any) => { 
          resolve(data);
          this.qtyProducts = this.shoppingCartList.length;
        },
        (err: any) => { reject(err) }
      );
    });
  }

  removeFromCart(userProcessId){  
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/${userProcessId}`;

      this.http.delete(url)
      .subscribe(
        (data: any) => { 
          resolve(data);
          this.qtyProducts = this.shoppingCartList.length;
        },
        (err: any) => { reject(err) }
      );
    });
  }

  payAll(data: any){
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/payment`;

      this.http.post(url, data)
      .subscribe(
        (data: any) => { resolve(data) },
        (err: any) => { reject(err) },
      );
    });
  }

  getListByAuthNumber(authNumber: any){
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/invoiceDetail/${authNumber}`;

      this.http.get( url )
      .subscribe(
        ( data: any ) => { resolve(data) },
        ( err: any ) => { reject(err) }
      )
    })
  }

  updatePaymentStatus(processCart){
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/updatePaymentStatus`;

      this.http.put(url, processCart)
      .subscribe(
        ( data: any ) => { resolve(data); },
        ( err: any ) => { reject(err); },
      )
    });
  }

  deleteSelection(selection){
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/deleteSelectedUserProcess`;

      this.http.post(url, selection)
      .subscribe(
        ( data: any ) => { resolve(data) },
        ( err: any ) => { reject(err) }
      )
    });
  }

  initPaymentPlan(cardInfo){
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/init`;
      
      this.http.post(url, cardInfo)
      .subscribe(
        (data: any) => { resolve(data) },
        (err: any) => { reject(err) }
      );
    })
  }

  paySelection(installment) {
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/pay`;

      this.http.post(url, installment)
      .subscribe(
        (data: any) => { resolve(data) },
        (err: any) => { reject(err) }
      );
    });
  }

  getPaymentPlanInvoice(){
    return new Promise((resolve, reject) => {
      let url = `${this.globals.dataUrl}${this.baseUrl}/invoicePaymentPlanInfo`;

      this.http.get(url)
      .subscribe(
        (data: any) => { resolve(data) },
        (err: any) => { reject(err) }
      );
    });
  }


}
